import { useEffect, useState } from 'react';

export function VersionBadge() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  const version = import.meta.env.DEV
    ? `v${__APP_VERSION__} dev`
    : `v${__APP_VERSION__}-${__BUILD_NUMBER__} ${__GIT_SHA__}`;

  useEffect(() => {
    if (import.meta.env.DEV) return;

    const check = async () => {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        if (data.sha && data.sha !== __GIT_SHA__) {
          setUpdateAvailable(true);
        }
      } catch { /* ignore */ }
    };

    const timeout = setTimeout(check, 10_000);
    const interval = setInterval(check, 2 * 60 * 1000);
    return () => { clearTimeout(timeout); clearInterval(interval); };
  }, []);

  if (updateAvailable) {
    return (
      <button
        onClick={() => window.location.reload()}
        className="fixed bottom-2 right-2 z-40 flex items-center gap-1.5 font-mono text-[10px] bg-surface-2/80 backdrop-blur px-2 py-1 rounded border border-line-1/30 hover:border-line-1/60 text-fg-3/80 transition-colors cursor-pointer select-none"
      >
        <span>{version}</span>
        <span className="text-accent-1">· Update available</span>
      </button>
    );
  }

  return (
    <div className="fixed bottom-2 right-2 z-40 pointer-events-none font-mono text-[10px] text-fg-3/40 hover:text-fg-3/80 transition-colors select-none">
      {version}
    </div>
  );
}
